import { TestIdDomain } from 'constants/testIds';

const scope = `${TestIdDomain.CONSTRUCTION}-draw-review`;

export const DrawReviewDrawerTestIds = {
  DRAWER: `${scope}.drawer`,
  DRAWER_CONTAINER: `${scope}.drawer-container`,
  CHECKLIST_OVERRIDE_CHECKBOX: `${scope}.checklist-override-checkbox`,
  DOCUMENT_VIEW_LINK: `${scope}.document-view-link`,
  SUMMARY_SECTION: `${scope}.summary-section`,
  LINE_ITEMS_SECTION: `${scope}.line-items-section`,
  LINE_ITEMS_OVER_REMAINING_ALERT: `${scope}.line-items-over-remaining-alert`,
  CHECKLIST_SECTION: `${scope}.checklist-section`,
  DOCUMENTS_SECTION: `${scope}.documents-section`,
  NOTES_FIELD: `${scope}.notes-field`,
  APPROVAL_BLOCKED_NOTE: `${scope}.approval-blocked-note`,
  APPROVE_BUTTON: `${scope}.approve-button`,
  DENY_BUTTON: `${scope}.deny-button`,
  REQUEST_CHANGES_BUTTON: `${scope}.request-changes-button`,
};
